<template>
  <button
    id="zoom-help-button"
    class="help-button"
    v-if="showZoomAgent"
    :style="style"
    @click.once="triggerLoadZoomAgent"
  >
    <svg
      v-if="loadingZoomAgent"
      aria-hidden="true"
      focusable="false"
      class="help-button__icon help-button__icon--loading nebula-icon nebula-icon--s"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" />
    </svg>
    <NebulaIcon
      v-else
      class="help-button__icon"
      size="s"
      symbol-id="chat-active"
    />
    <span>{{ $t('Chat') }}</span>
  </button>
</template>

<script>
import { NebulaIcon } from '@discoveryedu/nebula-components';
import { mapState } from 'pinia';
import { useUserStore } from '@/stores';
import { loadZendesk, loadZoomAgent } from '@/lib/help-button-chat';
import i18next from '@/lib/i18next';

export default {
  components: {
    NebulaIcon,
  },
  props: {
    verticalSpacingPx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loadingZoomAgent: false,
      showZendesk: false,
      showZoomAgent: false,
    };
  },
  computed: {
    ...mapState(useUserStore, [
      'user',
    ]),
    style() {
      return {
        bottom: `${this.verticalSpacingPx}px`,
      };
    },
  },
  created() {
    if (this.user?.analytics_data) {
      const countryCode = this.user.analytics_data.site.country_code.toUpperCase();
      // Zendesk is shown to users whose site is in GB and who have the support chat
      // product setting. It is hidden for students and for the thumbnail loader
      this.showZendesk = ['GB'].includes(countryCode);

      // Zoom is shown for users in US who don't have arabic set as their language
      this.showZoomAgent = ['US'].includes(countryCode)
        && i18next.language !== 'ar';
      // Initialize Zendesk and GTM
      if (this.showZendesk) {
        loadZendesk(countryCode);
      }
    }
  },
  methods: {
    triggerLoadZoomAgent() {
      this.loadingZoomAgent = true;

      loadZoomAgent(() => {
        this.loadingZoomAgent = false;
      });
    },
  },
};
</script>

<style lang="stylus">
.help-button {
  align-items: center;
  background: var(--nebula-color-platform-interactive-850);
  border: none;
  border-radius: var(--nebula-border-radius-button-pill);
  color: $nebula-color-white;
  cursor: pointer;
  display: flex;
  font-family: var(--nebula-font-family-display);
  font-size: var(--nebula-font-size-body-1);
  font-weight: 600;
  line-height: 1;
  padding: 11px var(--nebula-space-2x);
  position: fixed;
  right: 20px;
  text-decoration: none;
  z-index: 100;

  &__icon {
    fill: $nebula-color-white;
    margin-inline-end: var(--nebula-space-1x);

    &--loading {
      animation: help-button-icon-spin 0.75s linear infinite;
    }
  }
}

@keyframes help-button-icon-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
